import { REDIRECT_DEMAND_FILTER } from "../actionTypes";

export const redirectDemandFilter = (value) => ({
    type: REDIRECT_DEMAND_FILTER,
    payload: value,
  });